import React, { FC } from 'react'
import { Box } from '@mui/system'
import Typography from '@mui/material/Typography'

interface AppAlertBaseProps {
	iconBoxSx?: object
	iconSlot?: React.ReactNode
	title?: string | React.ReactNode
	subTitle?: string | React.ReactNode
}

const AppAlertBase: FC<AppAlertBaseProps> = ({
	iconBoxSx,
	iconSlot,
	title,
	subTitle,
}: AppAlertBaseProps) => {
	return (
		<>
			<Box
				sx={{
					position: 'absolute',
					left: '0.875rem',
					top: '0.75rem',
					bottom: '0.75rem',
					borderRadius: '0.9375rem',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					width: '3.125rem',
					height: '3.4375rem',
					...iconBoxSx,
				}}
				className={'alert-icon'}
			>
				{iconSlot}
			</Box>

			<Box>
				{typeof title === 'string' ? (
					<Typography
						fontFamily={'Gilroy-SemiBold, sans-serif'}
						textAlign={'left'}
						sx={{ wordBreak: 'break-word' }}
					>
						{title}
					</Typography>
				) : (
					title
				)}

				{typeof subTitle === 'string' ? (
					<Typography
						fontFamily={'Gilroy-Medium, sans-serif'}
						fontSize={'0.9375rem'}
						textAlign={'left'}
					>
						{subTitle}
					</Typography>
				) : (
					subTitle
				)}
			</Box>
		</>
	)
}

export default AppAlertBase
